import {
  sub,
  set,
  add,
  format,
  lastDayOfMonth,
  toDate,
  getMonth,
} from 'date-fns';
import ptBr from 'date-fns/locale/pt-BR';

export const months = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const abbrMonths = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Maio',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export const mapḾonths = months.reduce(
  (cur, acc, ind) => ({ ...acc, [cur]: ind + 1 }),
  {},
);

export const mapAbbrḾonths = months.reduce(
  (cur, acc, ind) => ({ ...acc, [cur]: ind + 1 }),
  {},
);

export const beforeMonthsForFilter = () => {
  const today = new Date();
  const meses = [];
  for (let i = 2; i <= 18; i++) {
    let newDate = sub(today, { months: i });
    newDate = set(newDate, { date: 1 });
    const data = {
      label: format(newDate, 'MMMM - yyyy', { locale: ptBr }),
      value: {
        start: newDate,
        end: lastDayOfMonth(newDate),
      },
    };
    meses.unshift(data);
  }
  return meses;
};

export const afterMonthsForFilter = () => {
  const today = new Date();
  const meses = [];
  for (let i = 2; i <= 18; i++) {
    let newDate = add(today, { months: i });
    newDate = set(newDate, { date: 1 });
    const data = {
      label: format(newDate, 'MMMM - yyyy', { locale: ptBr }),
      value: {
        start: newDate,
        end: lastDayOfMonth(newDate),
      },
    };
    meses.push(data);
  }
  return meses;
};

export const allMonthsForFilter = () => {
  const today = set(new Date(), { date: 1 });
  const lastMonth = sub(today, { months: 1 });
  const nextMonth = add(today, { months: 1 });
  const days = [
    {
      label: 'Mês passado',
      value: {
        start: lastMonth,
        end: lastDayOfMonth(lastMonth),
      },
    },
    {
      label: 'Este mês',
      value: {
        start: today,
        end: lastDayOfMonth(today),
      },
    },
    {
      label: 'Próximo mês',
      value: {
        start: nextMonth,
        end: lastDayOfMonth(nextMonth),
      },
    },
  ];
  const past = [...beforeMonthsForFilter()];
  const future = [...afterMonthsForFilter()];
  return [...days, ...past, ...future].map((d, k) => ({ ...d, id: k + 1 }));
};

const isBrokenMonth = (date1, date2) => {
  const month1 = getMonth(date1);
  const month2 = getMonth(date2);
  return month1 !== month2;
};

export const relatorioDateOptions = () => {
  const today = toDate(new Date());
  const sevenDays = sub(today, { days: 7 });
  const fifteenDays = sub(today, { days: 15 });
  let initLastMonth = sub(today, { months: 1 });
  initLastMonth = set(initLastMonth, { date: 1 });
  let endLastMonth = add(initLastMonth, { months: 1 });
  endLastMonth = sub(endLastMonth, { days: 1 });
  const initCurrentMonth = set(today, { date: 1 });
  let lastCurrentMonth = add(initCurrentMonth, { months: 1 });
  lastCurrentMonth = sub(lastCurrentMonth, { days: 1 });
  const initNextMonth = add(initCurrentMonth, { months: 1 });
  let endNextMonth = add(initNextMonth, { months: 1 });
  endNextMonth = sub(endNextMonth, { days: 1 });
  const initYear = set(today, { date: 1, month: 0 });
  let endYear = add(initYear, { years: 1 });
  endYear = sub(endYear, { days: 1 });

  const pastWeek = {
    init: sevenDays,
    end: today,
    isBrokenMonth: isBrokenMonth(today, sevenDays),
    blocked: true,
    label: 'Últimos 7 dias',
  };
  const pastTwoWeeks = {
    init: fifteenDays,
    end: today,
    isBrokenMonth: isBrokenMonth(today, fifteenDays),
    blocked: true,
    label: 'Últimos 15 dias',
  };
  const lastMonth = {
    init: initLastMonth,
    end: endLastMonth,
    blocked: true,
    label: 'Mês anterior',
  };
  const currentMonth = {
    init: initCurrentMonth,
    end: lastCurrentMonth,
    blocked: true,
    label: 'Mês atual',
  };
  const nextMonth = {
    init: initNextMonth,
    end: endNextMonth,
    blocked: true,
    label: 'Mês seguinte',
  };
  const thisYear = {
    init: initYear,
    end: endYear,
    blocked: true,
    label: 'Ano atual',
  };
  const personalizado = {
    label: 'Personalizado',
  };
  return [
    pastWeek,
    pastTwoWeeks,
    currentMonth,
    lastMonth,
    nextMonth,
    thisYear,
    personalizado,
  ].map((ele, id) => ({ ...ele, id: id + 1 }));
};
